import { useEffect } from 'react';

import qs from 'qs';
import { useLocation } from 'react-router';

import { useNavigate } from '@change-corgi/core/react/router';
import { useTracking } from '@change-corgi/core/react/tracking';

import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useIsStarter } from 'src/app/shared/hooks/session';

type UpdateUrlArgs = { pathname: string; search: string; navigate: ReturnType<typeof useNavigate> };
const updateUrl = ({ pathname, search, navigate }: UpdateUrlArgs) => {
	const parsedQuery = qs.parse(search, { ignoreQueryPrefix: true });
	const query = qs.stringify({ ...parsedQuery, started_flow: true });
	navigate(`${pathname}?${query.toString()}`, { replace: true });
};

export function useTrackSapView(): void {
	const track = useTracking();
	const sourceLocation = useQueryParamValue('source_location');
	const startedFlow = useQueryParamValue('started_flow');
	const isStarter = useIsStarter();
	const { pathname, search } = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		/**
		 * We only want to fire the `sap_view` event once per start of a session.
		 * Since there is a navigation for non-auth users mid-flow, we need to persist
		 * a value to prevent the `sap_view` from firing a second time when the user
		 * re-enters the flow after authenticating.
		 */
		if (!startedFlow) {
			void track('sap_view', {
				source_location: sourceLocation,
				is_starter: isStarter,
			});
			updateUrl({ pathname, search, navigate });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}
